import { channel } from '../plugins/signalr';

export function useAlerts()
{
    const { $alert } = useNuxtApp();

    return {
        $alert
    };
}

export function useEvents()
{
    const { $events } = useNuxtApp();

    return {
        $events
    };
}

export function useFilters()
{
    const { $filters } = useNuxtApp();

    return {
        $filters
    };
}

export function $t(key: string, ...replacements: any[])
{
    const { $t } = useNuxtApp();

    return $t(key, ...replacements);
}

export function useLocalization()
{
    const { $t, $i18n } = useNuxtApp();

    return {
        $t,
        $i18n
    };
}

export function useMedia()
{
    const store = useMediaStore();

    return {
        mq: () => store.mq,
        phone: () => store.phone,
        tablet: () => store.tablet,
        mobile: () => store.mobile,
        laptop: () => store.laptop,
        desktop: () => store.desktop
    };
}

export function useMixins()
{
    return {
        $redirect: navigateTo
    };
}

export function usePermissions()
{
    const { $permissions } = useNuxtApp();

    return {
        $permissions
    };
}

export function useSitemap()
{
    const { $sitemap } = useNuxtApp();

    return {
        $sitemap
    };
}

export function useAuth()
{
    const { $auth } = useNuxtApp();

    return {
        $auth
    };
}

export function useLogging()
{
    const { $log } = useNuxtApp();

    return {
        $log
    };
}

export function useFirebase()
{
    const { $firebase } = useNuxtApp();

    return {
        $firebase
    };
}

export function useSignalR()
{
    const { $channels } = useNuxtApp();

    return {
        $channels,
        channel
    };
}
